import PropTypes from 'prop-types';
import { InputWrapper, Input } from './InputField.style';

const InputField = ({ value, type, placeholder, onChange, name, leadingText, as, isValid }) => (
  <InputWrapper data-testid="input-field-wrapper" leadingText={leadingText} isValid={isValid}>
    <Input
      data-testid={name ? `input-field-${name}` : 'input-field'}
      value={value}
      type={type}
      placeholder={placeholder}
      onChange={onChange}
      name={name}
      as={as}
    />
  </InputWrapper>
);

InputField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  leadingText: PropTypes.string,
  as: PropTypes.string,
  isValid: PropTypes.bool,
};

InputField.defaultProps = {
  name: '',
  placeholder: '',
  leadingText: '',
  as: '',
  isValid: true,
};

export default InputField;
